import * as Yup from 'yup';

import { ISelectModel } from 'common/models/ISelectModel';

import { IMailTaskAttachment } from './IMailTaskAttachment';

export const MailTaskSchema = Yup.object().shape({
  languageId: Yup.number().required('Required'),
  to: Yup.array()
    .required('Required')
    .min(1, 'Required')
    .test('valid-emails', 'Invalid email format', value => {
      if (!value || value.length === 0) return false;

      return value.every(item => item?.value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item.value));
    }),
  attachments: Yup.array(),
  subject: Yup.string().required('Required'),
  autoLog: Yup.boolean().required('Required'),
});

export const MailTaskSchemaNoArrayEmail = Yup.object().shape({
  languageId: Yup.number().required('Required'),
  to: Yup.string().email().required('Required'),
  attachments: Yup.array(),
  subject: Yup.string().required('Required'),
  autoLog: Yup.boolean().required('Required'),
});

export interface IMailTask {
  templateId?: string;
  languageId: string | number;
  to: string[] | string | ISelectModel<string>[];
  attachments: IMailTaskAttachment[] | [];
  subject: string;
  body: string;
  autoLog?: boolean;
}
